import React from "react";
import {
  WSButton,
  WSElement,
  WSFlexBox,
  WSPage,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { WSQueries } from "../../../../query/WSQuery";
import { useQueryNotifications } from "../../../../query/notifications/queries/useQueryNotifications";
import { selectorFileSharingRequestContractorNotifications } from "../../selectors/selectorFileSharingRequestContractorNotifications";
import { useSession } from "@hooks/useSession";
import { useTrackClickNotification } from "../../utils/useTrackClickNotification";
import styles from "./styles.module.scss";
import { useRequirementInstructionsModal } from "../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { useGoToDashboardPayerRequirementDetails } from "../RouteRequirementDetails/RoutePayerRequirementDetails";

type RequestsToComplete = {
  title: string;
  description: string;
  onClick: () => Promise<void>;
};

export const RouteFilesToShare: React.FC = () => {
  const history = useHistory();
  const { personId } = useSession();
  const trackClickNotification = useTrackClickNotification(personId);
  const queryNotifications = useQueryNotifications();
  const goToPayerRequirementDetails = useGoToDashboardPayerRequirementDetails();

  const instructionsRequirementModal = useRequirementInstructionsModal();

  return (
    <WSQueries queries={{ queryNotifications }}>
      {({ queryNotificationsData }) => {
        const requests: RequestsToComplete[] = [];

        const notifications = selectorFileSharingRequestContractorNotifications(
          queryNotificationsData
        );
        notifications.forEach(notification => {
          const title = notification.context.requirement.requirementName;
          const payerName = notification.context.payer.payerName;
          const payerId = notification.context.payer.payerId;

          requests.push({
            title,
            description: `${title} file upload required requested by ${payerName}`,
            onClick: async () => {
              trackClickNotification(notification);
              const instructionsResult =
                await instructionsRequirementModal.open({
                  requirementId: notification.context.requirement.requirementId
                });

              if (instructionsResult !== true) return;

              goToPayerRequirementDetails({
                requirementId: notification.context.requirement.requirementId,
                payerId
              });
            }
          });
        });

        return (
          <WSPage
            breadcrumb={{
              label: "Back",
              onClick() {
                history.push("/member/dashboard");
              },
              icon: "arrow-left"
            }}
          >
            <WSText.Heading4 my="XL">
              File upload required ({requests.length})
            </WSText.Heading4>
            {requests.length === 0 ? (
              <WSText.ParagraphSm mt="3XL" align="center" color="gray400">
                No upload requests to complete
              </WSText.ParagraphSm>
            ) : (
              requests.map(({ title, description, onClick }) => {
                return (
                  <WSPanel
                    key={title}
                    mb="M"
                    as="label"
                    className={styles.item}
                  >
                    <WSFlexBox.CenterY justify="space-between" gap="M">
                      <WSElement>
                        <WSText weight="medium" pb="M">
                          {title}
                        </WSText>
                        <WSText.ParagraphSm>{description}</WSText.ParagraphSm>
                      </WSElement>
                      <WSButton.Secondary size="S" onAsyncClick={onClick}>
                        Complete requirement
                      </WSButton.Secondary>
                    </WSFlexBox.CenterY>
                  </WSPanel>
                );
              })
            )}
          </WSPage>
        );
      }}
    </WSQueries>
  );
};
